import { Component, Element, h, Host, Prop, State, Watch } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'module-progress-spinner-component',
  styleUrl: 'main-progress-spinner.scss',
  shadow: true,
})
export class ModuleProgressSpinner {
  componentDidLoad() {
    this.svgEl.style.strokeDashoffset = this.circumference.toString();
    wcShared.displayComponent('progress-spinner');
  }

  @Prop() readonly stroke = 2;
  @Prop() readonly radius = 14;
  @Prop() readonly progress: number;
  @State() normalizedRadius: number = this.radius - this.stroke * 2;
  @State() circumference: number = this.normalizedRadius * 2 * Math.PI;
  @Element() el: HTMLModuleProgressSpinnerComponentElement;

  private svgEl: SVGElement;

  private setProgress(percent) {
    const offset = this.circumference - (percent / 100) * this.circumference;
    this.svgEl.style.strokeDashoffset = offset.toString();
  }

  @Watch('progress')
  onNameChanged(newValue: number, oldValue: number) {
    if (newValue !== oldValue) {
      const percent = (100 * newValue) / 180;
      this.setProgress(percent);
    }
  }

  render() {
    return (
      <Host class={`theme-${wcShared?.store?.theme}`}>
        <svg
          height={this.radius * 2}
          width={this.radius * 2}
          class="svg-circle-progress"
        >
          <circle
            stroke="#E0E0E0"
            stroke-dasharray={this.circumference + ',' + this.circumference}
            stroke-width={this.stroke}
            fill="transparent"
            r={this.normalizedRadius}
            cx={this.radius}
            cy={this.radius}
          />
          <circle
            ref={(el) => {
              this.svgEl = el as SVGElement;
            }}
            stroke="#0098FF"
            stroke-dasharray={this.circumference + ',' + this.circumference}
            stroke-width={this.stroke}
            fill="transparent"
            r={this.normalizedRadius}
            cx={this.radius}
            cy={this.radius}
          />
        </svg>
      </Host>
    );
  }
}
